var order_status = {
  '-1': '已取消',
  0: '待确认',
  1: '进行中',
  2: '已完成'
}

var pay_status = {
  '-1': "支付失败",
  0: '待支付',
  1: ''
}

export {
  order_status,
  pay_status
}
